import { cn } from '@helpers/cn';
import { useInlineTranslation } from '@/i18n/hooks/useInlineTranslation';

export interface PlaceholderImageProps {
  className?: string;
}

const PlaceholderImage = ({ className }: PlaceholderImageProps) => {
  const { t } = useInlineTranslation();

  return (
    <img
      alt={t('placeholder')}
      src='https://assets.eye-able.com/dashboard-assets/icons/placeholder-image.png'
      className={cn('eye:h-[70px]', className)}
    />
  );
};

export default PlaceholderImage;
